import ContractTypeConstants from "@/helpers/Constants/ContractTypeConstants";

export default {
  data() {
    return {};
  },

  methods: {
    getViewRouteFromContractType(contractTypeId) {
      var contractType = this.getContactTypeById(contractTypeId);
      if (contractType.Id == ContractTypeConstants.ids.Draft) {
        return "ViewDraft";
      }

      var routeNameMap = {
        [ContractTypeConstants.typeTypes.Other]: "ViewContract",
        [ContractTypeConstants.typeTypes.Quotation]: "ViewQuotation",
        [ContractTypeConstants.typeTypes.ServiceJob]: "ViewServiceJobContract",
      }
      return routeNameMap[contractType.Type] || 'ViewContract';
    },

    getContactTypeById(contractTypeId) {
      var intId = parseInt(contractTypeId)
      return this.$store.getters["LookUpStore/ContractType"](intId);
    },

    getContractTypeIcon(contractTypeId) {
      var contractType = this.getContactTypeById(contractTypeId);
      if (!contractType) {
        return 'mdi-dot-medium'
      }

      if (contractType.Id == ContractTypeConstants.ids.Draft) {
        return "mdi-content-save-edit";
      }

      return ContractTypeConstants.typeTypeIcons[contractType.Type] || 'mdi-file-document-outline';
    },

    getContractTypeName(contractTypeId) {
      return this.getContactTypeById(contractTypeId)?.Name || 'Unknown';
    },

    contractTypeHasOrders(contractTypeId) {
      var contractType = this.getContactTypeById(contractTypeId);

      return contractType.Type === ContractTypeConstants.typeTypes.Other; //contracts and draft = other
    },

    getDetailText(detail) {
      if (detail.MachineId) {
        return detail.Machine.DisplayName;
      }
      //console.log(detail);

      var articleNumber = detail.Article ? detail.Article.ArticleNumber : (detail.ContractArticle ? detail.ContractArticle.ArticleNumber : '');
      if (articleNumber !== '') {
        articleNumber += ' ';
      }

      if (detail.ContractDetailGroup) {
        return articleNumber + detail.ContractDetailGroup;
      }
      else if (detail.Article) {
        return articleNumber + detail.Article.ArticleDescription;
      }
      else if (detail.ContractArticle) {
        return articleNumber + detail.ContractArticle.ArticleDescription;
      }
      else {
        return 'No article';
      }
    },
  },

  computed: {
    ContractTypeList() {
      return this.$store.getters["LookUpStore/ContractTypeList"];
    },

    LicenseFilteredContractTypeList() {
      var list = this.$store.getters["LookUpStore/ContractTypeList"];
      var showQuotation = this.checkIfLicencedByKey(ContractTypeConstants.QuotationLicenseKey);
      var showContracts = this.checkIfLicencedByKey(ContractTypeConstants.ContractLicenseKey);
      if (!showQuotation && !showContracts) {
        list = [];
      }
      else if (!showQuotation) {
        list = list.filter(type => type.Type === ContractTypeConstants.typeTypes.Other);
      }
      else if (!showContracts) {
        list = list.filter(type => type.Id !== ContractTypeConstants.typeTypes.Other);
      }
      return list;
    },

    ContractTypesLoading() {
      return this.$store.getters["BackgroundUpdater/Loading"]("ContractTypeMap");
    },
  },

  watch: {},
}